// School static content + assets
export const SCHOOL = {
  name: "B.R.Smart Kidz / Academy",
  shortName: "B.R.Smart Academy",
  tagline: "Digital Learning, Bright Future",
  established: "2 July 2018",
  estYear: "2018",
  foundation: "BRSK Foundation",
  foundationYear: "2021",
  address: "2, Natore Park 2nd Road, Kolkata - 700039",
  landline: "033-23432346",
  phones: ["7980239101", "7890239101"],
  email: "care.brsmartkidz@gmail.com",
  officeTiming: "9:30 AM - 4:00 PM (Mon - Fri)",
  schoolTiming: "8:00 AM - 5:00 PM (Mon - Fri)",
  session: "2026-27",
  mapEmbed:
    "https://www.google.com/maps?q=Natore+Park+2nd+Road+Kolkata+700039&output=embed",
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    youtube: "https://youtube.com",
  },
};

export const LOGO =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_smart-kidz-kolkata/artifacts/dgegh0xn_BD34A03A-D7FC-4A0E-91F1-E166F0D8A5C1.png";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/a9e62976d18622784a6cef93b1c24a8860ae231574743d37c5ffc049229c2b4a.jpeg",
  students: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/c787daf1f835b0519cc0de1b9b9e9bb103725b728bd4e038237eb74892aa017b.jpeg",
  annual: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/8025f857e20bf96c0fab145ace32f867013fc47c9caaa5714b7980ff97693e4a.jpeg",
  sports: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/31dec72c01c9076b14b69961a4e469faa66c0eb5bb6d8963962e60c574ef4422.jpeg",
  independence: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/65f86ef6c4158cefa38c8f9941904141eb88882e81ef66a190e6c2c3a98d7876.jpeg",
  smartClass: "https://static.prod-images.emergentagent.com/jobs/79e91f90-3769-4d4c-95d3-c0215f76bcd4/images/d2b97b607c14f79570b17d27ee741b70763eada7599243baab18fc824b7e712d.jpeg",
  computerLab: "https://customer-assets-m6fa6gv7.emergentagent.net/job_smart-kidz-kolkata/artifacts/a4vqq0rk_1F5EACD3-96AF-4696-884E-DB0F7C9A01C9.png",
  artCraft: "https://customer-assets-m6fa6gv7.emergentagent.net/job_smart-kidz-kolkata/artifacts/bjv9ftq6_CFF9118C-C99D-43CC-A996-8FFF1F9753F8.png",
  scienceLab: "https://customer-assets-m6fa6gv7.emergentagent.net/job_smart-kidz-kolkata/artifacts/x7onnh5p_6239C587-7763-4F63-94A3-689763D70758.png",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Academics", path: "/academics" },
  { label: "Admission", path: "/admission" },
  { label: "Facilities", path: "/facilities" },
  { label: "Gallery", path: "/gallery" },
  { label: "Notices", path: "/notices" },
];

export const MORE_LINKS = [
  { label: "Downloads", path: "/downloads" },
  { label: "Student Corner", path: "/student-corner" },
  { label: "Parent Corner", path: "/parent-corner" },
];

export const WHY_CHOOSE = [
  { icon: "Languages", title: "English Medium", desc: "Complete English medium instruction from Pre-Nursery onwards." },
  { icon: "BookOpenCheck", title: "CBSE Curriculum", desc: "Learning under the CBSE curriculum framework." },
  { icon: "GraduationCap", title: "Experienced Teachers", desc: "Qualified, caring & dedicated faculty." },
  { icon: "MonitorSmartphone", title: "Smart Classes", desc: "Interactive digital smart boards in every classroom." },
  { icon: "Laptop", title: "Computer Lab", desc: "Modern, well-equipped computer laboratory." },
  { icon: "Cctv", title: "CCTV Campus", desc: "24x7 CCTV surveillance for total safety." },
  { icon: "Snowflake", title: "AC Classrooms", desc: "Air-conditioned classrooms for a comfortable learning environment." },
  { icon: "Dumbbell", title: "PT & Karate", desc: "Physical training and self-defence karate classes." },
  { icon: "Sparkles", title: "Clean & Hygienic", desc: "Spotless, hygienic and child-friendly campus." },
  { icon: "HeartHandshake", title: "Individual Attention", desc: "Small batches ensuring personal care for every child." },
];

export const ACADEMIC_STAGES = [
  {
    key: "montessori",
    name: "Montessori",
    range: "Pre-Nursery, Nursery, Junior KG, Senior KG",
    color: "#E63946",
    classes: ["Pre-Nursery", "Nursery", "Junior KG", "Senior KG"],
    subjects: ["Play-way Learning", "Phonics & Rhymes", "Number Fun", "Art & Craft", "Story Time", "Physical Activity"],
    desc: "A joyful, play-based foundation that nurtures curiosity, motor skills and early literacy.",
  },
  {
    key: "primary",
    name: "Primary",
    range: "Class 1 to Class 4",
    color: "#F4A261",
    classes: ["Class 1", "Class 2", "Class 3", "Class 4"],
    subjects: ["English", "Hindi", "Bengali", "Mathematics", "EVS", "Computer", "G.K.", "Drawing"],
    desc: "Building strong fundamentals in language, mathematics and environmental awareness.",
  },
  {
    key: "secondary",
    name: "Secondary",
    range: "Class 5 to Class 10",
    color: "#2A9D8F",
    classes: ["Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10"],
    subjects: ["English", "Hindi", "Bengali", "Mathematics", "Science", "Social Science", "Computer", "Physical Education"],
    desc: "A rigorous academic programme preparing students for board examinations and beyond.",
  },
];

export const ALL_CLASSES = [
  "Pre-Nursery", "Nursery", "Junior KG", "Senior KG",
  "Class 1", "Class 2", "Class 3", "Class 4",
  "Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10",
];

export const FACILITIES = [
  { icon: "MonitorSmartphone", title: "Smart Classroom", desc: "Interactive smart boards make lessons lively and engaging.", image: IMAGES.smartClass },
  { icon: "Laptop", title: "Computer Lab", desc: "Hands-on digital learning with modern computers.", image: IMAGES.computerLab },
  { icon: "FlaskConical", title: "Science Lab", desc: "Explore, experiment and excel in our science laboratory.", image: IMAGES.scienceLab },
  { icon: "Palette", title: "Art & Craft Room", desc: "Create, imagine and inspire in the art & craft studio.", image: IMAGES.artCraft },
  { icon: "Trees", title: "Playground", desc: "Open, safe playground for sports and recreation.", image: IMAGES.sports },
  { icon: "Cctv", title: "CCTV Security", desc: "24x7 monitored, secure and safe campus.", image: IMAGES.hero },
];

export const ADMISSION_STEPS = [
  { title: "Enquiry & Registration", desc: "Fill the online admission form or visit the school office to register." },
  { title: "Document Submission", desc: "Submit the required documents along with the registration form." },
  { title: "Interaction", desc: "A friendly interaction with the child and parents." },
  { title: "Confirmation", desc: "On selection, pay the admission fee to confirm the seat." },
];

export const REQUIRED_DOCS = [
  "Birth Certificate (photocopy)",
  "4 recent passport-size photographs of the child",
  "Aadhaar Card of the child (if available)",
  "Aadhaar Card of both parents",
  "Previous school's Transfer Certificate (for Class 1 & above)",
  "Previous year's report card / marksheet",
  "Address proof of parents",
];

// Fallback downloads (admin can add more)
export const DEFAULT_DOWNLOADS = [
  { title: "Admission Form 2026-27", category: "Admission", description: "Printable admission application form." },
  { title: "School Prospectus", category: "Prospectus", description: "Complete school prospectus with details." },
  { title: "Holiday List 2026", category: "Holiday", description: "Annual holiday calendar." },
  { title: "Syllabus (All Classes)", category: "Syllabus", description: "Class-wise syllabus overview." },
];
